/* BOJOURNAL — exhibit.js
   <exhibit-view>: the Selected Works "exhibition" layout.
   Desktop: pointing at or focusing a title in the index brings its work into
   the viewer (soft crossfade). Every title is a real link, so nothing depends
   on this behaviour. Once the section approaches the viewport, the remaining
   images are loaded so a hover never waits. Phones: plain swipe, no JS needed. */
(() => {
  const B = window.Bojournal;
  if (!B || !B.Component || customElements.get('exhibit-view')) return;

  class ExhibitView extends B.Component {
    init() {
      this.slides = [...this.querySelectorAll('[data-exhibit-slide]')];
      this.items = [...this.querySelectorAll('[data-exhibit-item]')];
      if (this.slides.length < 2) return;
      const show = (event) => {
        const item = event.target.closest('[data-exhibit-item]');
        if (!item) return;
        clearTimeout(this._t);
        // A short intent delay: sweeping the pointer across the list does
        // not flash every work in turn.
        this._t = setTimeout(() => this.activate(Number(item.dataset.exhibitItem)), event.type === 'focusin' ? 0 : 70);
      };
      this.on(this, 'mouseover', show);
      this.on(this, 'focusin', show);

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this._io.disconnect();
            this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
          },
          { rootMargin: '400px 0px' }
        );
        this._io.observe(this);
      }
    }

    teardown() {
      clearTimeout(this._t);
      if (this._io) this._io.disconnect();
    }

    activate(index) {
      if (index === this.index) return;
      this.index = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
    }
  }

  B.define('exhibit-view', ExhibitView);
})();
